import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-minus-2', 'CircleMinus2', [["path",{"d":"M20.475 15.029a9 9 0 1 0 -7.962 5.957"}],["path",{"d":"M16 19h6"}]]);